// / =============================================================================
// PERMISSION COMPONENTS
// =============================================================================

import { Shimmer } from "components/shimmer";
import { usePermissionRules } from "permissions/hooks/usePermissionRules";

// Rule-based permission gate
export const PermissionGate = ({
  rule,
  rules,
  collection,
  fallback = null,
  children,
}) => {
  const { data: permissions, isLoading } = usePermissionRules(
    rules || [rule],
    collection
  );

  if (isLoading) {
    return <Shimmer className="w-20 h-4" />;
  }

  if (!permissions ) {
    return fallback;
  }

  // Check if any of the rules pass
  const hasPermission = Object.values(permissions).some(Boolean);

  if (!hasPermission) {
    return fallback;
  }

  return children;
};
